
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/closing-costs",
      function () {
        return require("private-next-pages/tools/closing-costs/index.tsx");
      }
    ]);
  